import React from "react";
import Link from '@material-ui/core/Link';
import CloseIcon from '@material-ui/icons/Close'; 
import { useSelector } from "react-redux";

const GQInlinePopup = (props) => {
    const toggle = useSelector(state => state.setToggle.toggle);

    const { innerHtml, show, close, disabled, styles } = props;

    return (
    <>
    {show && !disabled &&
    <div style={styles != null ? styles : {width: "max-content", position: "absolute", opacity: "100%", zIndex: 1000, border: "1px solid #ccc", backgroundColor: toggle? 'white':'#292929', padding: "5px", boxShadow: "0px 0px 10px rgba(0,0,0,0.5)", borderRadius: "8px"}}>  
        <div style={{ width:"100%",display: "flex", justifyContent: "flex-end", margintop: "-5px"}}>
            <Link className={"appTextColor"}><CloseIcon onClick={() => {close();}} /></Link>
        </div>
                            
        <div>
            {innerHtml}
        </div>
    </div>
    }
    </>
    );

}

export default GQInlinePopup;